import { createElement } from "@wordpress/element";
/**
 * WordPress dependencies
 */
import { __experimentalToolsPanelContext as ToolsPanelContext } from '@wordpress/components';
import { useContext } from '@wordpress/element';
export default function BlockSupportSlotContainer({
  Slot,
  ...props
}) {
  const toolsPanelContext = useContext(ToolsPanelContext);
  return createElement(Slot, {
    ...props,
    fillProps: toolsPanelContext,
    bubblesVirtually: true
  });
}
//# sourceMappingURL=block-support-slot-container.js.map